<div *ngIf="type == 'view'" style="position:relative">
    <a (click)="openOpenAppModal(app)" title="{{app.name}}">
        <!-- <i *ngIf="allowVault" class="manage-apps-icon-right manage-apps-icon-right-view feather key" [ngClass]="{'enabled': app.quick_login == true}" (click)="openEditAppModal($event, app)"></i> -->
        <img *ngIf="app.company == null" src="{{app.logo}}" alt="{{app.name}}"
            class="manage-apps-logo">
        <img *ngIf="app.company != null"
            src="{{app.logo == null || app.logo == '' ? 'assets/img/logos/default.png' : app.logo}}" alt="{{app.name}}"
            class="manage-apps-logo">
        <div class="app-name" title="{{app.name}}">{{app.name}}</div>
        <div class="app-description" title="{{app.category}}">{{app.category}}</div>
    </a>
</div>

<div *ngIf="type == 'button'" title="{{app.name}}">
    <i class="manage-apps-icon feather package" placement="right" tooltip="Global library"></i>
    <img *ngIf="app.company == null" src="{{app.logo}}" alt="{{app.name}}"
        class="manage-apps-logo">
    <img *ngIf="app.company != null"
        src="{{app.logo == null || app.logo == '' ? 'assets/img/logos/default.png' : app.logo}}" alt="{{app.name}}"
        class="manage-apps-logo">
    <div class="app-name" title="{{app.name}}">{{app.name}}</div>
    <div class="app-description" title="{{app.category}}">{{app.category}}</div>
</div>